// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ErrorController = function ($scope, $modalInstance, error) {
    $scope.error = error;
    $scope.close = function () {
        $modalInstance.close();
    };
};
ErrorController.$inject = ["$scope", "$uibModalInstance", "error"];
